import { render, staticRenderFns } from "./PostFacebook.vue?vue&type=template&id=4730dcfc"
import script from "./PostFacebook.vue?vue&type=script&lang=js"
export * from "./PostFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4730dcfc')) {
      api.createRecord('4730dcfc', component.options)
    } else {
      api.reload('4730dcfc', component.options)
    }
    module.hot.accept("./PostFacebook.vue?vue&type=template&id=4730dcfc", function () {
      api.rerender('4730dcfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PostFacebook.vue"
export default component.exports